import { generateExponential } from 'rf-ui/GameRenderer/customEasing';
import type { RandomSpin } from './types';

export default abstract class SpinProvider {

  protected readonly spinSpeedMs: number;

  protected readonly defaultWholeRounds: number;

  constructor(spinSpeedMs: number) {
    this.spinSpeedMs = spinSpeedMs;
    this.defaultWholeRounds = Math.floor(spinSpeedMs / 3_000);
  }

  protected static counterClockwise(counterClockwiseChance: number): boolean {
    return Math.random() < counterClockwiseChance;
  }

  defaultSpin = (): RandomSpin => ({
    time: this.spinSpeedMs,
    wholeRounds: this.defaultWholeRounds,
    clockWise: false,
    easing: generateExponential(300).Out,
    ticker: true,
    hand: false
  });

  abstract getRandomSpin(roundsLeft: number, counterClockwiseChance: number, isBehind: boolean): RandomSpin;
}
